import { render, staticRenderFns } from "./achangeKefuLogin.vue?vue&type=template&id=5e56bcaf&scoped=true&"
import script from "./achangeKefuLogin.vue?vue&type=script&lang=js&"
export * from "./achangeKefuLogin.vue?vue&type=script&lang=js&"
import style0 from "./achangeKefuLogin.vue?vue&type=style&index=0&id=5e56bcaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56bcaf",
  null
  
)

export default component.exports